module.exports = __webpack_public_path__ + "static/media/jobsandpro.f45aac02.svg";